import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);
    if (result.success) {
      toast.success('Logged in successfully!');
      navigate('/');
    } else {
      toast.error(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full bg-white p-8 border border-[#E5E7EB]">
        <div className="mb-8">
          <Link to="/" className="flex justify-center items-center mb-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_drive-hub-27/artifacts/1glibbg5_logo%202.png" 
              alt="Motoring Daily" 
              className="h-16 w-auto"
            />
          </Link>
          <h2 className="mt-6 text-center text-3xl font-bold text-[#0A1128] font-heading">
            Motoringdaily Sign In
          </h2>
          <p className="mt-2 text-center text-sm text-[#666666]">
            Motoringdaily access only
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm font-semibold text-[#1A1A1A] mb-2 uppercase tracking-wide">
              Email Address
            </label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-[#F8F9FA] border border-[#E5E7EB] focus:border-[#00A859] focus:ring-1 focus:ring-[#00A859] rounded-none px-4 py-3 text-[#1A1A1A] w-full transition-colors"
              data-testid="email-input"
              placeholder="Enter your email"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-semibold text-[#1A1A1A] mb-2 uppercase tracking-wide">
              Password
            </label>
            <input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-[#F8F9FA] border border-[#E5E7EB] focus:border-[#00A859] focus:ring-1 focus:ring-[#00A859] rounded-none px-4 py-3 text-[#1A1A1A] w-full transition-colors"
              data-testid="password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#00A859] hover:bg-[#008a49] text-white font-bold uppercase tracking-wider py-3 px-6 rounded-none transition-colors duration-200 disabled:opacity-50"
            data-testid="submit-btn"
          >
            {loading ? 'Please wait...' : 'Sign In'}
          </button>
        </form>


      </div>
    </div>
  );
};